import { useEffect, useLayoutEffect, useState } from "react";

const STEPS = [
  { target: "paychecks", title: "Pay Checkboxes", body: "Expecting multiple checks this month? Enter your net numbers here and check them off as they hit your account to automatically recalculate your fluid cash." },
  { target: "expenses", title: "4-Week Micro-Tracking", body: "Slide your common category expenses into their exact calendar week. Tap the bell icon next to any field to lock in a due date alert." },
  { target: "summary", title: "Your Real-Time Profit Net", body: "This displays exactly what you have left after mandatory bills are subtracted from your active pay, tracking week by week." },
];

export default function OnboardingTooltips({ onDone }) {
  const [step, setStep] = useState(0);
  const [rect, setRect] = useState(null);

  const measure = () => {
    const el = document.querySelector(`[data-onboard="${STEPS[step].target}"]`);
    if (el) {
      el.scrollIntoView({ block: "center", behavior: "smooth" });
      const r = el.getBoundingClientRect();
      setRect({ top: r.top, left: r.left, width: r.width, height: r.height });
    } else {
      setRect(null);
    }
  };

  useLayoutEffect(() => {
    const t = setTimeout(measure, 250);
    window.addEventListener("resize", measure);
    return () => { clearTimeout(t); window.removeEventListener("resize", measure); };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [step]);

  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => { document.body.style.overflow = ""; };
  }, []);

  const next = () => { if (step < STEPS.length - 1) setStep(step + 1); else onDone(); };

  const s = STEPS[step];
  const pad = 8;
  const cardTop = rect ? Math.min(rect.top + rect.height + 12, window.innerHeight - 220) : window.innerHeight / 2 - 100;
  const cardLeft = rect ? Math.min(Math.max(rect.left, 16), window.innerWidth - 340) : window.innerWidth / 2 - 160;

  return (
    <div className="fixed inset-0 z-[100]" data-testid="snap-onboarding">
      <div className="absolute inset-0 bg-black/70" onClick={next} />
      {rect && (
        <div
          className="absolute rounded-xl ring-2 ring-emerald-400 pointer-events-none transition-all duration-300"
          style={{ top: rect.top - pad, left: rect.left - pad, width: rect.width + pad * 2, height: rect.height + pad * 2, boxShadow: "0 0 0 9999px rgba(0,0,0,0.55)" }}
        />
      )}
      <div
        className="absolute w-[320px] bg-[#0d1730] border border-emerald-500/30 rounded-2xl p-5 shadow-2xl transition-all duration-300"
        style={{ top: cardTop, left: cardLeft }}
      >
        <div className="flex items-center gap-2 mb-2">
          <img src="/snapbudget-logo.webp" alt="" className="w-6 h-6 rounded" />
          <span className="text-[10px] uppercase tracking-wider text-emerald-400 font-mono">Step {step + 1} of {STEPS.length}</span>
        </div>
        <h3 className="text-white font-bold text-lg">{s.title}</h3>
        <p className="text-slate-400 text-sm mt-1.5 leading-relaxed">{s.body}</p>
        <div className="flex items-center justify-between mt-4">
          <button onClick={onDone} data-testid="snap-onboard-skip" className="text-xs text-slate-500 hover:text-slate-300">Skip tour</button>
          <button onClick={next} data-testid="snap-onboard-next" className="h-9 px-4 rounded-lg bg-emerald-500 text-[#04140c] text-sm font-semibold hover:bg-emerald-400 transition-colors">
            {step < STEPS.length - 1 ? "Next" : "Got it"}
          </button>
        </div>
      </div>
    </div>
  );
}
